import { useSelector } from 'react-redux';
import { selectShowEditOtherChargesModal } from '../../app-selectors';
import EditOtherChargesModal from './EditOtherChargesModal';

export const EditOtherChargesModalConnected = () => {
  const isModalOpen = useSelector(selectShowEditOtherChargesModal);

  return isModalOpen ? <EditOtherChargesModal /> : null;
};
